/* eslint-disable prettier/prettier */

;
(function (ng) {
  'use strict';

  var CartCheckoutCtrl = function (toaster, $timeout, $http, cartCheckoutService, modalService, $interval, urlHelper) {
    var ctrl = this,
      timer;
    ctrl.isSelectedPoint = false;
    ctrl.viewCheckoutPage = false;
    ctrl.listStage = [{
      id: 1,
      name: 'Доставка'
    }, {
      id: 2,
      name: 'Оплата'
    }, {
      id: 3,
      name: 'Ваш заказ'
    }];
    ctrl.selectedStage = ctrl.listStage[0];
    ctrl.cartCheckoutService = cartCheckoutService;
    ctrl.$onInit = function () {
      cartCheckoutService.getShipping().then(data => {
        ctrl.shippings = data.option;
        ctrl.viewCheckoutPage = true;
      });
      cartCheckoutService.getPayment().then(data => {
        ctrl.payment = data.option;
        ctrl.paymentSelected = data.selectShipping;
        console.log(data);
      });
      ctrl.addressLists();
      ctrl.initStageFourPay();
    };
    ctrl.openModalAddres = isEdit => {
      var options = {
        'modalClass': 'addres-block-modal',
        'isOpen': true,
        'destroyOnClose': true,
        'isShowFooter': false
      };
      ctrl.isEditAddressModal = isEdit;
      ctrl.editingAddres = {
        FirstName: ctrl.customeDrata.FirstName,
        Name: ctrl.customeDrata.LastName,
        Phone: ctrl.customeDrata.Phone
      };
      ctrl.isEditTypeAddres = false;
      ctrl.loadYandexMap({
        apikey: "69a34c05-619c-44ec-969f-e76099865ac9",
        lang: 'ru-RU'
      });
      modalService.renderModal('modalAddresCustomer', null, '<div class="addres-modal-selected" data-ng-include="\'/Templates/Promo/Areas/Mobile/scripts/_partials/cart/modals/addressCustomer.html\'"></div>', null, options, {
        checkoutModal: ctrl
      });
    };
    ctrl.saveAddres = () => {
      if (!(ctrl.editingAddres != undefined && ctrl.editingAddres != null && ctrl.editingAddres.City != undefined && ctrl.editingAddres.City.length > 0)) {
        toaster.pop('Нужно ввести город');
        return;
      }
      $http.post('../Checkout/SaveAddress', {
        contact: ctrl.editingAddres
      }).then(res => {
        ctrl.customerAddres = res.data.customerAddres;
        ctrl.mainAddres = res.data.mainAddres;
        if (ctrl.isEditTypeAddres) {
          ctrl.isEditAddressModal = true;
        } else {
          ctrl.closeModalAddres();
        }
      });
    };
    ctrl.addressLists = () => {
      $http.post('../Checkout/GetAddressList').then(res => {
        ctrl.customerAddres = res.data.customerAddres;
        ctrl.mainAddres = res.data.mainAddres;
      });
      $http.post('../Checkout/GetCustomerData').then(res => {
        ctrl.customeDrata = res.data;
      });
    };
    ctrl.deleteAddres = contactId => {
      $http.post('../Checkout/deleteAddres', {
        contactId
      }).then(res => {
        ctrl.customerAddres = res.data.customerAddres;
        ctrl.mainAddres = res.data.mainAddres;
        if (ctrl.isEditTypeAddres) {
          ctrl.isEditAddressModal = true;
        } else {
          ctrl.closeModalAddres();
        }
      });
    };
    ctrl.contactUpdateMain = contactId => {
      $http.post('../Checkout/contactUpdateMain', {
        contactId
      }).then(res => {
        ctrl.customerAddres = res.data.customerAddres;
        ctrl.mainAddres = res.data.mainAddres;
      });
    };
    ctrl.closeModalOnEditAddresPage = () => {
      if (ctrl.isEditTypeAddres) {
        if (ctrl.isEditAddressModal) {
          ctrl.closeModalAddres();
        } else {
          ctrl.isEditAddressModal = true;
        }
      } else {
        ctrl.closeModalAddres();
      }
    };
    ctrl.closeModalAddres = () => {
      modalService.close("modalAddresCustomer");
      cartCheckoutService.getShipping().then(data => {
        ctrl.shippings = data.option;
      });
    };
    ctrl.preEditContact = address => {
      ctrl.editingAddres = address;
      ctrl.isEditAddressModal = false;
      ctrl.isEditCurrentAddres = true;
    };
    ctrl.nextStage = function () {
      let stageId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      let nextSage = ctrl.listStage.filter(stage => stage.id == ctrl.selectedStage.id + 1);
      if (ctrl.validStage()) {
        if (nextSage[0].id == 2) {
          let getPayment = () => {
            cartCheckoutService.getPayment().then(data => {
              ctrl.payment = data.option;
              ctrl.paymentSelected = data.selectShipping;
              ctrl.selectedStage = nextSage[0];
            });
          };
          if (!ctrl.shippingSelected.HideAddressBlock) {
            console.log(ctrl.editingAddres);
            $http.post('../Checkout/SaveAddressDesctop', {
              contact: ctrl.editingAddres
            }).then(res => {
              console.log(res);
              if (res.data.errors != undefined && res.data.errors.length > 0) {
                toaster.pop("error", '', res.data.errors[0]);
                return;
              }
              ctrl.customerAddres = res.data.customerAddres;
              ctrl.mainAddres = res.data.mainAddres;
              getPayment();
            });
          } else {
            getPayment();
          }
        } else {
          ctrl.selectedStage = nextSage[0];
        }
      }

      //Понижение этапа оформления
      if (stageId > 0 && ctrl.selectedStage.id > stageId) {
        nextSage = ctrl.listStage.filter(stage => stage.id == stageId);
        ctrl.selectedStage = nextSage[0];
      }
    };
    ctrl.validStage = () => {
      let checkField = partAddres => partAddres != undefined && partAddres.length > 0;

      //проверка 1 стадии
      if (ctrl.selectedStage.id == 1) {
        if (ctrl.shippingSelected != undefined && ctrl.shippingSelected.Id != undefined) {
          //console.log(ctrl.mainAddres);
          if (!ctrl.shippingSelected.HideAddressBlock && ctrl.editingAddres != null && checkField(ctrl.editingAddres.City) && checkField(ctrl.editingAddres.Street) && checkField(ctrl.editingAddres.House)) {
            return true;
          } else if (ctrl.shippingSelected.HideAddressBlock && ctrl.isSelectedPoint) {
            return true;
          }
        }
      }
      if (ctrl.selectedStage.id == 2) {
        if (ctrl.paymentSelected != undefined && ctrl.paymentSelected.Id != undefined) {
          if (ctrl.paymentSelected.PaymentKey == 'CashOnDelivery' && ctrl.cartCheckoutInfo.Count > 2) {
            return false;
          } else {
            return true;
          }
        }
      }
      return false;
    };
    ctrl.saveShipping = () => {
      cartCheckoutService.saveShipping(ctrl.shippingSelected).then(data => {
        ctrl.initStageFourPay();
      });
    };
    ctrl.savePayment = () => {
      cartCheckoutService.savePayment(ctrl.paymentSelected).then(data => {
        console.log(data);
        ctrl.initStageFourPay();
      });
    };
    ctrl.initStageFourPay = () => {
      cartCheckoutService.getCheckoutCart().then(data => {
        ctrl.cartCheckoutInfo = data;
        ctrl.stagePaymentsItems = data.ResultsNumber;
        ctrl.updateShipping({
          deliveryCost: ctrl.cartCheckoutInfo.DeliveryCustom,
          //ctrl.shippingSelected.FormatRateCustom,
          totalCost: ctrl.cartCheckoutInfo.ResultCustom
        });
      });
    };
    ctrl.changeShippingControl = shipping => {
      ctrl.isSelectedPoint = true;
      cartCheckoutService.saveShipping(ctrl.shippingSelected).then(data => {
        ctrl.shippingSelected = data.selectShipping;
      });
    };
    ctrl.createOrder = () => {
      $http.post('./Checkout/IndexPostCustom', {
        CustomData: 'Оформление через новую корзину',
        OrderType: 5,
        IsLanding: false
      }).then(res => {
        if (res.data.result) {
          location.replace("checkout/success/" + res.data.obj);
        } else {
          console.log(res);
        }
      });
    };
    ctrl.getNameCheckoutBtn = paymentKey => {
      switch (paymentKey) {
        case "Cash":
          return "Оформить заказ";
        case "ModuleTinkoffDolyame":
          return "Оплатить долями";
        case "ModuleAlfaPodeli":
          return "Оплатить с подели";
        case "CashOnDelivery":
          return "Оформить заказ";
        case "Tinkoff":
          return "Оплатить заказ";
        default:
          return "Оплата заказа";
      }
    };

    //#region write addres

    ctrl.loadYandexMap = function (params) {
      if (window.yandexMapLoaded) {
        // загрузка api карт уже вызвана
        // defer.resolve() будет вызван по загрузке скрипта
      } else {
        if (document.querySelector('script[src*="api-maps.yandex.ru"]') != null) {
          // уже кем-то запущена загрузка api карт
          //ctrl.waitingInitYmaps();
        } else {
          // сразу устанавливаем флаг, чтобы больше небыло попыток загрузить
          window.yandexMapLoaded = true;
          var script = document.createElement('script');
          script.src = 'https://api-maps.yandex.ru/2.1/?' + urlHelper.paramsToString(angular.extend({
            lang: 'ru-RU'
          }, params || {}));
          document.body.appendChild(script);
        }
      }
    };
    ctrl.checkWriteAddress = $interval(() => {
      if (ctrl.loadAddress && !ctrl.loadProcessAddres && ctrl.editingAddres != undefined && ctrl.editingAddres.City != undefined && ctrl.editingAddres.City.length > 3) {
        ctrl.loadProcessAddres = true;
        var myGeocoder = ymaps.geocode(ctrl.editingAddres.City, {
          kind: 'street'
        });
        console.log(myGeocoder);
        try {
          myGeocoder.then(function (res) {
            ctrl.geoLists = res.geoObjects.toArray().map(geo => {
              var data = geo.properties.get('metaDataProperty');
              if (data.GeocoderMetaData.Address.country_code != "RU") return null;
              return data.GeocoderMetaData.Address;
            }).filter(addres => addres != null);
            ctrl.loadAddress = false;
            ctrl.loadProcessAddres = false;
            console.log(ctrl.geoLists);
          }, data => {
            ctrl.loadAddress = false;
            ctrl.loadProcessAddres = false;
          });
        } catch (ex) {
          console.log(ex);
        }
      }
    }, 100);

    //ctrl.checkWriteStreet = $interval(() => {
    //    if (ctrl.loadStreet &&
    //        !ctrl.loadProcessStreet &&
    //        ctrl.editingAddres != undefined &&
    //        ctrl.editingAddres.City != undefined &&
    //        ctrl.editingAddres.City.length > 3 &&
    //        ctrl.editingAddres.Street != undefined &&
    //        ctrl.editingAddres.Street.length > 3)
    //    {
    //        ctrl.loadProcessStreet = true;
    //        var myGeocoder = ymaps.geocode(ctrl.editingAddres.City + " ул. " + ctrl.editingAddres.Street, {
    //            kind: 'house',
    //            results: 10
    //        });
    //        try {
    //            myGeocoder.then(
    //                function (res) {

    //                    console.log(res.geoObjects.toArray());
    //                    ctrl.geoAddressLists = res.geoObjects.toArray()
    //                        .map(geo => {
    //                            var data = geo.properties.get('metaDataProperty');
    //                            if (data.GeocoderMetaData.Address.country_code != "RU")
    //                                return null;
    //                            return data.GeocoderM
    //                        })
    //                        .filter(addres => addres != null);
    //                    ctrl.loadStreet = false;
    //                    ctrl.loadProcessStreet = false;
    //                    console.log(ctrl.geoLists);
    //                },
    //                (data) => {
    //                    ctrl.loadStreet = false;
    //                    ctrl.loadProcessStreet = false;
    //                }
    //            );
    //        }
    //        catch (ex) {
    //            console.log(ex);
    //        }
    //    }
    //}, 100);

    ctrl.searchListAddress = () => {
      if (ctrl.timeLoad != null) $timeout.cancel(ctrl.timeLoad);
      ctrl.timeLoad = $timeout(() => {
        ctrl.loadAddress = true;
      }, 500);
    };

    //ctrl.searchListStreet = () => {
    //    if (ctrl.timeLoad != null)
    //        $timeout.cancel(ctrl.timeLoad);

    //    ctrl.timeLoad = $timeout(() => {
    //        ctrl.loadStreet = true;
    //    }, 500);
    //}

    ctrl.changeAddress = geo => {
      //установка адреса при выборе его из списка
      console.log(geo);
      ctrl.editingAddres.City = geo.Components.filter(c => c.kind == "locality")[0].name;
      ctrl.geoLists = [];
    };
    ctrl.setShipping = shipping => {
      if (ctrl.shippingSelected != undefined && ctrl.shippingSelected != null && ctrl.shippingSelected.Id == shipping.Id) return;
      ctrl.shippingSelected = shipping;
      ctrl.saveShipping();
    };

    //#endregion 
  };

  angular.module('cart').controller('CartCheckoutCtrl', CartCheckoutCtrl);
  CartCheckoutCtrl.$inject = ['toaster', '$timeout', '$http', 'cartCheckoutService', 'modalService', '$interval', 'urlHelper'];
})(angular);